import { useCallback } from 'react';

import { requestBuilder } from '../../../http/RequestBuilder';
import { captureException } from '../../../logger/Logger';

interface CompleteMemberSignupParams {
    userId: string;
}

const useMutateMemberSignUp = requestBuilder.mutation<
    undefined,
    undefined,
    CompleteMemberSignupParams
>({
    endpoint: ({ userId }) => `/api/user/${userId}/sign-up-complete`,
    method: 'POST',
});

export const useCompleteMemberSignup = () => {
    const { mutateAsync, isPending } = useMutateMemberSignUp();

    const completeMemberSignup = useCallback(
        async ({ userId }: CompleteMemberSignupParams) => {
            await mutateAsync(
                {
                    urlParams: { userId },
                },
                {
                    onError(e) {
                        captureException(e);
                    },
                },
            );
        },
        [mutateAsync],
    );

    return { completeMemberSignup, isCompletingMemberSignup: isPending };
};
